// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as Sheet from "../../primitives/Sheet.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let fileTypes = [
  "csv",
  "spreadsheetml"
];

function decodeRowVariantId(json) {
  if (json === null || json === Json.encodeString("")) {
    return {
      TAG: "Error",
      _0: "Empty"
    };
  }
  let option = Stdlib_Option.map(Stdlib_Option.flatMap(Json.decodeString(json), Uuid.fromString), prim => prim);
  if (option !== undefined) {
    return {
      TAG: "Ok",
      _0: option
    };
  } else {
    return {
      TAG: "Error",
      _0: "Unkown"
    };
  }
}

function decodeRowStock(json) {
  if (json === null || json === Json.encodeString("")) {
    return {
      TAG: "Error",
      _0: "Empty"
    };
  }
  let number = Stdlib_Option.orElse(Stdlib_Option.map(Stdlib_Option.map(Json.decodeString(json), string => string.replace(",", ".")), prim => Number(prim)), Json.decodeNumber(json));
  if (number !== undefined) {
    if (Number.isNaN(number)) {
      return {
        TAG: "Error",
        _0: "NotNumber"
      };
    } else if (isFinite(number)) {
      if (number < 0) {
        return {
          TAG: "Error",
          _0: "Negative"
        };
      } else {
        return {
          TAG: "Ok",
          _0: number
        };
      }
    } else {
      return {
        TAG: "Error",
        _0: "NonFinite"
      };
    }
  } else {
    return {
      TAG: "Error",
      _0: "Unknown"
    };
  }
}

let dictVariantIdKey = I18n.t("ID");

let dictStockKey = I18n.t("Inventory quantity");

function decodeRowValues(jsonVariantId, jsonStock, index) {
  let variantId = decodeRowVariantId(jsonVariantId);
  let stock = decodeRowStock(jsonStock);
  if (variantId.TAG !== "Ok") {
    if (variantId._0 === "Empty") {
      return {
        TAG: "Error",
        _0: {
          TAG: "EmptyCellVariantId",
          index: index
        }
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          TAG: "CannotDecodeCellVariantId",
          index: index,
          json: jsonVariantId
        }
      };
    }
  }
  if (stock.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: {
        variantId: variantId._0,
        stock: stock._0
      }
    };
  }
  switch (stock._0) {
    case "Empty" :
      return {
        TAG: "Error",
        _0: {
          TAG: "EmptyCellStock",
          index: index
        }
      };
    case "Negative" :
      return {
        TAG: "Error",
        _0: {
          TAG: "NegativeCellStock",
          index: index,
          json: jsonStock
        }
      };
    default:
      return {
        TAG: "Error",
        _0: {
          TAG: "CannotDecodeCellStock",
          index: index,
          json: jsonStock
        }
      };
  }
}

function decodeDictRowWithIndex(index, dictRow) {
  let match = dictRow[dictVariantIdKey];
  let match$1 = dictRow[dictStockKey];
  if (match !== undefined && match$1 !== undefined) {
    return decodeRowValues(match, match$1, index);
  } else {
    return {
      TAG: "Error",
      _0: {
        TAG: "CannotDecodeHeaderRow",
        index: index,
        json: Json.encodeDict(dictRow)
      }
    };
  }
}

function decodeTupleRowWithIndex(index, tupleRow) {
  let match = tupleRow[0];
  let match$1 = tupleRow[1];
  if (match !== undefined && match$1 !== undefined) {
    return decodeRowValues(match, match$1, index);
  } else {
    return {
      TAG: "Error",
      _0: {
        TAG: "CannotDecodeRow",
        index: index,
        json: Json.encodeArray(tupleRow)
      }
    };
  }
}

function decodeRows(headerIndexOffsetOpt, rows) {
  let headerIndexOffset = headerIndexOffsetOpt !== undefined ? headerIndexOffsetOpt : 0;
  let decodedRows = rows.map((jsonRow, index) => {
    let match = Json.decodeArray(jsonRow);
    let match$1 = Json.decodeDict(jsonRow);
    if (match !== undefined) {
      return decodeTupleRowWithIndex(index, match);
    } else if (match$1 !== undefined) {
      return decodeDictRowWithIndex(index + headerIndexOffset | 0, match$1);
    } else {
      return {
        TAG: "Error",
        _0: {
          TAG: "CannotDecodeRow",
          index: index + headerIndexOffset | 0,
          json: jsonRow
        }
      };
    }
  });
  let okRowsCount = Stdlib_Array.filterMap(decodedRows, row => {
    if (row.TAG === "Ok") {
      return row._0;
    }
  }).length;
  let errorRowsCount = Stdlib_Array.filterMap(decodedRows, row => {
    if (row.TAG === "Ok") {
      return;
    } else {
      return Primitive_option.some(undefined);
    }
  }).length;
  if (errorRowsCount === 0 && okRowsCount === 0) {
    return {
      TAG: "Error",
      _0: "NoRows"
    };
  }
  if (!(errorRowsCount > 0 && okRowsCount === 0)) {
    return {
      TAG: "Ok",
      _0: decodedRows
    };
  }
  let errorCannotDecodeHeaderRowCount = Stdlib_Array.filterMap(decodedRows, row => {
    if (row.TAG === "Ok" || row._0.TAG !== "CannotDecodeHeaderRow") {
      return;
    } else {
      return Primitive_option.some(undefined);
    }
  }).length;
  let errorEmptyStockCellCount = Stdlib_Array.filterMap(decodedRows, row => {
    if (row.TAG === "Ok" || row._0.TAG !== "EmptyCellStock") {
      return;
    } else {
      return Primitive_option.some(undefined);
    }
  }).length;
  if (errorCannotDecodeHeaderRowCount === errorRowsCount) {
    return {
      TAG: "Error",
      _0: "InvalidHeaderRow"
    };
  } else if (errorEmptyStockCellCount === errorRowsCount) {
    return {
      TAG: "Error",
      _0: "EmptyColumnStock"
    };
  } else {
    return {
      TAG: "Ok",
      _0: decodedRows
    };
  }
}

function parseAndDecodeCsvFile(file) {
  return Future.map(Future.flatMapOk(Future.mapError(Sheet.parseCsvFile(file), undefined, () => "Unknown"), undefined, rows => Future.value(decodeRows(undefined, rows))), undefined, result => ({
    headerOffset: 0,
    payload: result
  }));
}

function parseAndDecodeXlsxFile(initialHeaderIndexOffset, file) {
  let headerIndexOffset = Stdlib_Option.getOr(initialHeaderIndexOffset, 1);
  return Future.map(Future.flatMapError(Future.flatMapOk(Future.mapError(Sheet.parseExceljsXlsxFile(headerIndexOffset, file), undefined, () => "Unknown"), undefined, rows => Future.value(decodeRows(headerIndexOffset, rows))), undefined, error => {
    if (error === "InvalidHeaderRow" && Stdlib_Option.isNone(initialHeaderIndexOffset)) {
      return Future.map(parseAndDecodeXlsxFile(0, file), undefined, result => result.payload);
    } else {
      return Future.value({
        TAG: "Error",
        _0: error
      });
    }
  }), undefined, result => ({
    headerOffset: headerIndexOffset,
    payload: result
  }));
}

export {
  fileTypes,
  decodeRowVariantId,
  decodeRowStock,
  dictVariantIdKey,
  dictStockKey,
  decodeRowValues,
  decodeDictRowWithIndex,
  decodeTupleRowWithIndex,
  decodeRows,
  parseAndDecodeCsvFile,
  parseAndDecodeXlsxFile,
}
/* dictVariantIdKey Not a pure module */
